import { render } from "./Help.vue?vue&type=template&id=0754b146&scoped=true"
import script from "./Help.vue?vue&type=script&lang=js"
export * from "./Help.vue?vue&type=script&lang=js"

import "./Help.vue?vue&type=style&index=0&id=0754b146&scoped=true&lang=css"

import exportComponent from "/home/pdu/dbesslnc2-20251202/dbesslnc2.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0754b146"]])

export default __exports__